export var formatCpf = function (value) {
    if (!value) {
        return '';
    }
    var onlyNumbers = value.replace(/\D/g, '');
    var cpfWithMask = onlyNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    return cpfWithMask;
};
export var formatCnpj = function (value) {
    if (!value) {
        return '';
    }
    var onlyNumbers = value.replace(/\D/g, '');
    var cnpjWithMask = onlyNumbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    return cnpjWithMask;
};
export var formatCep = function (value) {
    if (!value) {
        return '';
    }
    var onlyNumbers = value.replace(/\D/g, '');
    var cepWithMask = onlyNumbers.replace(/(\d{5})(\d{3})/, '$1-$2');
    return cepWithMask;
};
/** Máscara dinâmica: fixo (10 dígitos) ou celular (11 dígitos). Ordem fixo primeiro para priorizar (XX) XXXX-XXXX ao digitar 10 dígitos. */
export var PHONE_MASK = [
    { mask: '(00) 0000-0000' }, // telefone fixo
    { mask: '(00) 00000-0000' }, // celular
];
export var formatPhone = function (value) {
    if (!value) {
        return '';
    }
    var onlyNumbers = value.replace(/\D/g, '');
    if (onlyNumbers.length === 11) {
        // celular (9 dígitos + DDD)
        return onlyNumbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (onlyNumbers.length === 10) {
        // fixo (8 dígitos + DDD)
        return onlyNumbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return value;
};
export var limitString = function (title) {
    if (title.length <= 20) {
        return title;
    }
    else {
        return title.substring(0, 20) + '...';
    }
};
